import type { NavigateFunction } from 'react-router';

interface FinalizeNavigateParams {
  session?: { currentTask?: unknown } | null;
  decorateUrl: (url: string) => string;
}

/**
 * Creates a navigate callback for signIn.finalize() / signUp.finalize().
 * Clerk v6 custom flow pattern — decorateUrl handles dev-mode JWT (Safari ITP).
 */
export const createFinalizeNavigate =
  (routerNavigate: NavigateFunction, destination = '/') =>
  ({ decorateUrl }: FinalizeNavigateParams) => {
    const url = decorateUrl(destination);

    if (url.startsWith('http')) {
      window.location.href = url;
    } else {
      void routerNavigate(url);
    }
  };
